import React, {useCallback} from "react";
import {connect} from "react-redux";
import {AutoSizer, List, WindowScroller} from "react-virtualized";

import PricingFeatureRow from "./PricingFeatureRow";
import {
  getFeaturePropertiesGridColumnStyles, useGetPricingFilteredFeatures,
} from "./pricingFeaturesFunctions";
import PricingFeaturesListTableHeader from "./PricingFeaturesListTableHeader";
import {pricingEditFeature} from "../pricingActions";


const PricingFeaturesList = (props) => {

  const {pricingFeaturesList, pricingFeaturesReceived, searchTerm, selectedFilters, pricingFeaturesColumns,
    pricingEditFeature, pricingEditedFeatures} = props;

  const scrollContainer = document.querySelector(".app-content-wrapper--fullpage");
  const columns = ["index", ...pricingFeaturesColumns];

  const featuresList = useGetPricingFilteredFeatures(
    pricingFeaturesList,
    pricingFeaturesReceived,
    searchTerm,
    selectedFilters
  );

  console.log("featuresList", pricingFeaturesList, columns);

  const styles = getFeaturePropertiesGridColumnStyles(columns);

  return (
    <div className="height-100 pr-grid-virtualized">
      <PricingFeaturesListTableHeader styles={styles} columns={columns}/>
      <WindowScroller scrollElement={scrollContainer}>
        {({height, scrollTop, onChildScroll}) => height ? (
          <AutoSizer disableHeight>
            {({width}) => {
              return (
                <List
                  autoHeight
                  height={height}
                  onScroll={onChildScroll}
                  rowCount={featuresList.length}
                  rowHeight={44}
                  rowRenderer={({index, key, style}) => {
                    if (!featuresList[index]) {
                      return null
                    }
                    return <PricingFeatureRow dbFeature={featuresList[index]}
                                              featurePropertyChange={pricingEditFeature}
                                              pricingEditedFeatures={pricingEditedFeatures}
                                              index={index}
                                              key={key}
                                              columns={columns} style={{...style, ...styles}}/>
                  }}
                  scrollTop={scrollTop}
                  width={width}
                />
              )
            }}
          </AutoSizer>
        ) : null}
      </WindowScroller>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingFeaturesList, pricingFeaturesReceived, pricingFeaturesColumns, pricingEditedFeatures} = store.pricingState;
  const {selectedFilters} = store.featuresFiltersState;
  const {searchTerm} = store.featuresSetupState;

  return {
    pricingFeaturesList,
    searchTerm,
    pricingFeaturesReceived,
    pricingFeaturesColumns,
    selectedFilters,
    pricingEditedFeatures,
  };
};

const mapDispatchToProps = {
  pricingEditFeature,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFeaturesList);
